module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woman_a8035b.png";